import { styled } from "@linaria/react";

export const ElSection = styled.section`
  width: 100%;
`;
